import type { AllStatuses } from '@library/types/status';
import { StatusIndicator } from '@library/components/StatusIndicator';
import { formatDate } from '@library/component-utils/dateTime';

export interface AutotradeHistoryRowProps {
  status: AllStatuses;
  reason: string;
  projectionValue: number;
  probabilityOfMore: string;
  timestamp: string;
  dataSource: string;
}

export const AutotradeHistoryRow = ({
  status,
  reason,
  projectionValue,
  probabilityOfMore,
  timestamp,
  dataSource
}: AutotradeHistoryRowProps) => {
  return (
    <div className="text-soClean-100 flex w-full justify-between py-4 text-xs font-thin">
      <div className="flex w-2/12 items-center px-2">
        <StatusIndicator className="rounded-md pr-2" status={status} />
        <div className="text-soClean-100 capitalize">{status}</div>
      </div>
      <div className="w-3/12 px-2">{reason}</div>
      <div className="flex w-2/12 justify-center px-2">
        {projectionValue ?? '-'}
      </div>
      <div className="flex w-2/12 justify-center px-2">
        {Number(probabilityOfMore).toFixed(4) ?? '-'}
      </div>
      <div className="w-2/12 px-2">
        {formatDate({ date: timestamp, pattern: 'MMM dd yyyy; HH:MM' })}
      </div>
      <div className="w-1/12 px-2">{dataSource ?? '-'}</div>
    </div>
  );
};
